module.exports = __webpack_public_path__ + "zvetseni-prsou_32_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_32_after.jpg
// module id = 1325
// module chunks = 0